export default __webpack_public_path__ + "static/media/gallery-mock.6ec736bb.png";